module.exports = __webpack_public_path__ + "img/alcyon.7d80ac90.png";